export default "__VITE_ASSET__D5753GyK__"